<template>
  <div>
        <!-- 面包屑导航 -->
        <el-breadcrumb separator=">">
      <el-breadcrumb-item>COHORT分析</el-breadcrumb-item>
      <el-breadcrumb-item>激活绑卡率Cohort</el-breadcrumb-item>
    </el-breadcrumb>
    <el-divider></el-divider>

    <div class="container">
      <div style="margin-bottom: 20px; margin-right: 80px; " size="medium">
        <el-radio-group v-model="radioType"   >
          <el-radio-button label="pad">pad</el-radio-button>
          <el-radio-button label="app">app</el-radio-button>
          <el-radio-button label="all">all</el-radio-button>
          <el-radio-button label="xbike">xbike</el-radio-button>
          <el-radio-button label="litbike">litbike</el-radio-button>
          <el-radio-button label="boombike">boombike</el-radio-button>
          <el-radio-button label="boombasic">boombasic</el-radio-button>
          <el-radio-button label="ebike">ebike</el-radio-button>
          <el-radio-button label="other">other</el-radio-button>
        </el-radio-group>

     
      </div>
    </div>
    <el-table :data="tableData" stripe style="width: 100%" height="850">

      <el-table-column prop="title" label="cohort" width="180">
      </el-table-column>




      <el-table-column prop="count" label="初始计数">
      </el-table-column>



      <el-table-column v-for="period in periods" :key="period" :prop="period" :label="period" width="80">
        <template slot-scope="{ row }">
          <span :style="{ backgroundColor: getBackgroundColor(row.cohort_rate[periods.indexOf(period)]), color:'#ffffff', }">
            {{ row.cohort_rate[periods.indexOf(period)] }}</span>
        </template>
      </el-table-column>


    </el-table>



  </div>
</template>
  
<script>



export default {
  data() {
    return {
      tableData: [],
      radioType:'pad',
  
      periods: ["1月", "2月", "3月", "4月", "5月", "6月", "7月", "8月", "9月", "10月", "11月", "12月", "13月", "14月", "15月"
        , "16月", "17月", "18月", "19月", "20月", "21月", "22月", "23月", "24月", "25月", "26月", "27月", "28月", "29月", "30月"],
    }
  },

  watch: {


    radioType(newV, oldVal) {
      this.getData(newV)
    }
  },



  created: function () {
    //注意回调函数的作用域!!!
  },
  mounted: function () {

    this.getData(this.radioType);
   // console.log(" cohort_subs   挂载完毕");
  },



  methods: {
    getBackgroundColor(rateS) {
      let rate=parseFloat(rateS)
      if (rateS =='-') {
        return "#ffffff"; // 高比率的背景颜色
      }
       if (rate >= 95) {
        return "#00FF00"; // 高比率的背景颜色
      } else if (rate >= 93) {
        return "#10F000"; // 
      } else if (rate >= 91) {
        return "#20e000"; // 
      } else if (rate >= 89) {
        return "#30d000"; // 
      } else if (rate >= 87) {
        return "#40c000"; // 
      } else if (rate >= 85) {
        return "#50b000"; // 
      } else if (rate >= 83) {
        return "#60a000"; // 
      } else if (rate >= 81) {
        return "#709000"; // 
      } else if (rate >= 79) {
        return "#808000"; // 
      } else if (rate >= 75) {
        return "#907000"; // 
      } else if (rate >= 70) {
        return "#a06000"; // 
      } else if (rate >= 65) {
        return "#b05000"; // 
      } else if (rate >= 60) {
        return "#c04000"; // 
      } else if (rate >= 50) {   
        return "#d03000"; // 
      } else if (rate >= 40) {   
        return "#e02000"; // 
      } else if (rate >= 20) {   
        return "#f01000"; // 
      } else {
        return "#ff0000";  // 低比率的背景颜色
      }
    },

    async  getData(bike_type){
      let res = await this.$http.get("/da/cohort_binding/"+this.radioType)  
      this.tableData = res.data
       // console.log(res.data)
    },

  }
}
</script>
  
  <!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.container {
  display: flex;
  justify-content: flex-end;
}
</style>
  
  